<div
  class="ctrl-border flex h-ie"
  [ngClass]="{
    'ctrl-border--error': hasError,
    'opacity-40': disabled
  }"
  role="none"
>
  <div
    class="h-full w-[132px] border-r-1 border-solid border-po-gray-200 bg-white"
  >
    <aw-country-prefix-select
      #prefixSelect
      class="h-full"
      [attr.name]="id | awId: 'country'"
      [class.opacity-40]="disabled"
      [value]="prefix"
      [panelWidth]="fieldWidth"
      [disabled]="disabled"
      (valueChange)="onPrefixChange($event)"
    />
  </div>

  <div class="relative h-full flex-1">
    <input
      #input
      class="text-body-regular h-full w-full border-none px-3 text-black !ring-0"
      data-testid="phoneInput"
      data-cy="phoneInput"
      autocomplete="tel-national"
      pattern="[0-9]*"
      type="tel"
      [attr.id]="id | awId: 'field'"
      [placeholder]="placeholder"
      [name]="id | awId: 'field'"
      [mask]="'0*'"
      [disabled]="disabled"
      [ngModel]="nationalNumber"
      (ngModelChange)="onInputChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
  </div>
</div>
